const styles = {
  card: {
    marginTop: '1em',
  },
};

export default styles;
